import { render, staticRenderFns } from "./ProvisionalRemedyRequest.vue?vue&type=template&id=e4badce4&scoped=true"
import script from "./ProvisionalRemedyRequest.vue?vue&type=script&lang=js"
export * from "./ProvisionalRemedyRequest.vue?vue&type=script&lang=js"
import style0 from "./ProvisionalRemedyRequest.vue?vue&type=style&index=0&id=e4badce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4badce4",
  null
  
)

export default component.exports